export default "__VITE_ASSET__CjoxhpO6__"